import React from 'react';
import { Card, CardBody, Skeleton } from '@heroui/react';

const ProductCardSkeleton: React.FC = () => {
  return (
    <Card className="h-full bg-white dark:bg-gray-900 border border-gray-200/60 dark:border-gray-800/60">
      {/* Header Skeleton */}
      <div className="relative overflow-hidden bg-gradient-to-br from-gray-200 to-gray-300 dark:from-gray-800 dark:to-gray-700">
        <CardBody className="relative p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1 min-w-0 pr-2">
              <div className="flex items-center gap-2 mb-2">
                <Skeleton className="w-6 h-6 rounded" />
                <Skeleton className="h-6 w-32 rounded" />
              </div>
              <Skeleton className="h-4 w-full rounded mb-2" />
              <Skeleton className="h-4 w-3/4 rounded" />
            </div>
            <Skeleton className="w-20 h-6 rounded-full" />
          </div>
          <Skeleton className="w-24 h-6 rounded-full" />
        </CardBody>
      </div>

      {/* Content Skeleton */}
      <CardBody className="p-6">
        {/* Metrics */}
        <div className="grid grid-cols-3 gap-4 mb-6">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="text-center">
              <Skeleton className="h-8 w-12 mx-auto mb-2 rounded" />
              <Skeleton className="h-3 w-16 mx-auto rounded" />
            </div>
          ))}
        </div>

        {/* Features */}
        <div className="mb-6">
          <Skeleton className="h-4 w-24 mb-3 rounded" />
          <div className="space-y-2">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="flex items-center space-x-2">
                <Skeleton className="w-4 h-4 rounded" />
                <Skeleton className="h-4 flex-1 rounded" />
              </div>
            ))}
          </div>
        </div>

        {/* Users */}
        <div className="mb-6">
          <Skeleton className="h-4 w-20 mb-2 rounded" />
          <div className="flex flex-wrap gap-1">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="h-6 w-16 rounded-full" />
            ))}
          </div>
        </div>

        {/* Actions */}
        <div className="space-y-2">
          <Skeleton className="h-12 w-full rounded-lg" />
          <div className="flex space-x-2">
            <Skeleton className="h-10 flex-1 rounded-lg" />
            <Skeleton className="h-10 flex-1 rounded-lg" />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default ProductCardSkeleton;

